module.exports = __webpack_public_path__ + "static/Iria-d4e9eb2ac8c1813ee19c1bf4712d88ab.png";